'use client';
import { WatcherNetworkSelectMultiple } from '#/components/legacy/watcher-network-select-multiple';
import { Button } from '#/components/ui/button';
import { Dialog, DialogTrigger } from '#/components/ui/dialog';
import { HelpTooltip } from '#/components/v2/help-tooltip';
import { useTranslation } from '#/contexts/useTranslation';
import { AddAddressDialogContent } from '#/modules/dialogs/add-address-dialog';
import { Translation } from 'intl-lib';
import { PlusCircle } from 'lucide-react';
import { useState } from 'react';
import { PortfolioDistributionChart } from './portfolio-distribution-chart';
import { PortfolioValueHistoryChart } from './portfolio-history-chart';
import { PortfolioTotalValue } from './portfolio-total-value';
import StakingAddressesTable from './staking-addresses-table';
import { StakingNetworksTable } from './staking-networks-table';

export default function Page() {
  const translation = useTranslation();
  const [symbols, setSymbols] = useState<string[]>([]);
  const [isAddAddressOpen, setIsAddAddressOpen] = useState(false);
  return (
    <>
      <h2 className="text-3xl @3xl/main:text-4xl tracking-tight font-bold text-gray-900 dark:text-white">
        {translation.PortfolioDashboard.Heading}
      </h2>
      <div className="flex flex-col space-y-8">
        <section className="bg-white dark:bg-gray-700 rounded-2xl p-4 @3xl/main:p-6 space-y-6">
          <div className="flex flex-col">
            <div>
              <p className="font-medium text-gray-500 text-sm @3xl/main:text-base dark:text-gray-400">
                {translation.PortfolioDashboard.CurrentPortfolioValue}
              </p>
              <div className="mt-2 space-x-1">
                <PortfolioTotalValue />
                <HelpTooltip
                  content={
                    translation.PortfolioDashboard.CurrentPortfolioValueHelp
                  }
                />
              </div>
            </div>
            <div className="grid mt-5 grid-cols-5 gap-6">
              <div className="col-span-full @7xl/main:col-span-2 h-72">
                <PortfolioDistributionChart />
              </div>
              <div className="col-span-full @7xl/main:col-span-3 h-72">
                <PortfolioValueHistoryChart />
              </div>
            </div>
            <div className="mt-6">
              <StakingNetworksTable />
            </div>
          </div>
        </section>
        <section className="bg-white dark:bg-gray-700 rounded-2xl p-4 @3xl/main:p-6 flex flex-col space-y-6">
          <div className="flex justify-between items-center">
            <p className="font-bold text-gray-800 text-xl @3xl/main:text-2xl dark:text-gray-200">
              {translation.PortfolioDashboard.ManageYourAddresses.Heading}{' '}
              <HelpTooltip
                content={
                  translation.PortfolioDashboard.ManageYourAddresses.HeadingHelp
                }
              />
            </p>
            <div className="flex items-center space-x-4">
              <div className="hidden @5xl/main:block">
                <WatcherNetworkSelectMultiple
                  // size="large"
                  // className="w-64"
                  value={symbols}
                  onValueChange={value => setSymbols(value)}
                  placeholder={
                    <Translation path="PortfolioDashboard.ManageYourAddresses.FilterNetwork.Placeholder" />
                  }
                />
              </div>
              <Dialog>
                <DialogTrigger asChild>
                  <Button variant="primary" size="sm" className="shrink-0">
                    <PlusCircle className="h-4 w-4" />
                    {translation.PortfolioDashboard.AddAddress.ButtonLabel}
                  </Button>
                </DialogTrigger>
                <AddAddressDialogContent />
              </Dialog>
            </div>
          </div>
          <div>
            <StakingAddressesTable symbols={symbols} />
          </div>
        </section>
      </div>
    </>
  );
}
